<mat-card-header>
	<mat-card-title #res>
		Region {{regionCode}} - Resolved Duplicates <span
			*ngIf="!isLoading && routeMsg.SUCCESS && duplicateResolutions && duplicateResolutions.length > 0 ">
			({{duplicateResolutionsDataSource.filteredData.length === duplicateResolutions.length ?
			duplicateResolutions.length :
			(duplicateResolutionsDataSource.filteredData.length + '/' + duplicateResolutions.length)}})
		</span>


		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>


<div class="row">

	<div class="col-4 inline">
		<mat-form-field class="w-100">
			<mat-label>
				Start Date
			</mat-label>
			<input matInput [(ngModel)]="startDate" [matDatepicker]="startDatePicker" (click)="startDatePicker.open()"
				startView="multi-year" (ngModelChange)="refreshResolvedDuplicatesByRegion()" [disabled]="isLoading">
			<mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #startDatePicker startView="multi-year"
				[startAt]="startDateOptions.startAt"></mat-datepicker>
		</mat-form-field>
	</div>

	<div class="col-4 inline">
		<mat-form-field class="w-100">
			<mat-label>
				End Date
			</mat-label>
			<input matInput [(ngModel)]="endDate" [matDatepicker]="endDatePicker" (click)="endDatePicker.open()"
				startView="multi-year" (ngModelChange)="refreshResolvedDuplicatesByRegion()" [disabled]="isLoading">
			<mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #endDatePicker startView="multi-year" [startAt]="endDateOptions.startAt"></mat-datepicker>
		</mat-form-field>
	</div>

	<div class="col-4 inline">
		<mat-checkbox [color]="'primary'" class="checkbox-margin" [(ngModel)]="showSystemDuplicateResolutions"
			(ngModelChange)="refreshResolvedDuplicatesByRegion()" [disabled]="isLoading">
			Show Resolved by System
		</mat-checkbox>
	</div>


</div>

<hr />

<div class="margin-top-md row gx-0" [hidden]="isLoading">
	<mat-form-field class="col-lg-12">
		<mat-label>
			Filter
		</mat-label>
		<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
			(ngModelChangeDebounced)="setFilter();" />
	</mat-form-field>
</div>

<div class="margin-top-md"
	*ngIf="!isLoading && routeMsg.SUCCESS && duplicateResolutions && duplicateResolutions.length > 0">
	<div *ngFor="let dr of duplicateResolutionsSlice; let i = index;" class="margin-top-md">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>{{dr.DUPLICATE_RESOLUTION_TYPES.TYPE}} - Created by <span
						class="primary">{{dr.CREATED_BY}}</span> on
					{{dr.CREATED_DATE|cleanDate|simpleDate}}</mat-card-title>
				<mat-card-subtitle>{{dr.MODIFIED_BY ? 'Updated by ' : ''}}
					<span class="primary">{{dr.MODIFIED_BY ? dr.MODIFIED_BY : ''}}</span>
					{{dr.MODIFIED_BY ? ' on ' +
					(dr.MODIFIED_DATE|cleanDate|simpleDateTime) : ''}}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<div class="table-responsive margin-top-sm" *ngIf="!isLoading">
					<mat-table [dataSource]="duplicateResolutionStudentsDataSources[i]" class="mat-elevation-z1">

						<ng-container matColumnDef="EDIT">
							<mat-header-cell *matHeaderCellDef>
								<children-deduplication-compare-btn
									[studentId1]="dr.DUPLICATE_RESOLUTION_STUDENTS[0].STUDENTS_ID"
									[studentId2]="dr.DUPLICATE_RESOLUTION_STUDENTS[1].STUDENTS_ID"></children-deduplication-compare-btn>
							</mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div aria-label="Modifed By" matTooltipClass="bigger-tooltip" class="primary"
									[matTooltip]="(element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_DATE|simpleDateTime)"
									matTooltipPosition="above"
									[matTooltipDisabled]="!element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_BY || element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_BY === ''">
									{{element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].MODIFIED_BY}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE">
							<mat-header-cell *matHeaderCellDef> Region </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.DUPLICATE_RESOLUTION_STUDENT_REGIONS ?
								element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE : ''}}
							</mat-cell>
						</ng-container>

						<ng-container
							matColumnDef="DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS">
							<mat-header-cell *matHeaderCellDef> Resolved </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div [ngClass]="{
										'primary italic': element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS === 'Same'
										, 'warn italic': element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS === 'Different'
										, 'italic': element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS === 'Undecided'
										, 'bold': true
									}">
									{{element.DUPLICATE_RESOLUTION_STUDENT_REGIONS ?
									element.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS
									: ''}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.MSD_NUMBER">
							<mat-header-cell *matHeaderCellDef> MSD # </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div [ngClass]="{'line-through': element.STUDENT.DUPLICATE_DEACTIVATE > 0}">
									{{element.STUDENT.MSD_NUMBER}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.PERSON.LAST_NAME">
							<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<edit-child-modal-btn [studentId]="element.STUDENT.ID" [type]="'string'"
									[displayText]="element.STUDENT.NAME">
								</edit-child-modal-btn>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.DOB">
							<mat-header-cell *matHeaderCellDef> DOB </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.DOB | simpleDate}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.MULTI_BIRTH">
							<mat-header-cell *matHeaderCellDef> MB </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.MULTI_BIRTH}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.BIRTH_VERIFY">
							<mat-header-cell *matHeaderCellDef> BV </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.BIRTH_VERIFY}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.BIRTH_CITY">
							<mat-header-cell *matHeaderCellDef> Birth City </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.BIRTH_CITY | titlecase}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.SEX">
							<mat-header-cell *matHeaderCellDef> Gender </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.STUDENT.SEX}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.LEGAL_MOTHERS[0].FIRST_NAME">
							<mat-header-cell *matHeaderCellDef> Mother (Legal P/G 2) </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									<ul>
										<li *ngFor="let item of element.STUDENT.LEGAL_MOTHERS">{{item.FIRST_NAME |
											titlecase}}
											{{item.LAST_NAME | titlecase}}</li>
									</ul>
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT.LEGAL_FATHERS[0].FIRST_NAME">
							<mat-header-cell *matHeaderCellDef> Father (Legal P/G 1) </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div>
									<ul>
										<li *ngFor="let item of element.STUDENT.LEGAL_FATHERS">{{item.FIRST_NAME |
											titlecase}}
											{{item.LAST_NAME | titlecase}}</li>
									</ul>
								</div>
							</mat-cell>
						</ng-container>

						<ng-container
							matColumnDef="DUPLICATE_RESOLUTION_STUDENT_PROPERTIES[0].DUPLICATE_RESOLUTION_STUDENT_PROPERTY_TYPES.TYPE">
							<mat-header-cell *matHeaderCellDef> Reason </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div>
									<ul>
										<li *ngFor="let item of element.DUPLICATE_RESOLUTION_STUDENT_PROPERTIES">
											{{item.DUPLICATE_RESOLUTION_STUDENT_PROPERTY_TYPES.TYPE}}</li>
									</ul>
								</div>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>
				</div>
			</mat-card-content>
			<mat-card-actions *ngIf="featurePermissions['Revert Duplicate Students']">
				<div *ngIf="dr.CAN_RESOLVE === 'Same' && dr.DUPLICATE_RESOLUTION_TYPES.TYPE === 'Resolved'">
					<table class="table table-borderless">
						<tfoot>
							<tr>
								<td colspan="2">
									<confirm-popover [type]="'button'" [buttonTxt]="'Revert Merge'"
										[popoverMsg]="'Are you sure you want to revert this duplicate? These students will be un-merged.'"
										[color]="'accent'" (onConfirm)="revertDuplicateResolutionMerged(dr)"
										[disabled]="dr.RESOLVING">
									</confirm-popover>
									<mat-icon *ngIf="dr.RESOLVING">
										<mat-spinner diameter="20"> </mat-spinner>
									</mat-icon>
								</td>
								<td colspan="11">
									Is this incorrect? Changing the status to Provisional will
									allow
									the
									regions to update their decision. Children will be un-merge.
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
				<div *ngIf="dr.CAN_RESOLVE === 'Different' && dr.DUPLICATE_RESOLUTION_TYPES.TYPE === 'Resolved'">
					<table class="table table-borderless">
						<tfoot>
							<tr>
								<td colspan="2">
									<confirm-popover [type]="'button'" [buttonTxt]="'Revert Different'"
										[popoverMsg]="'Are you sure you want to revert this duplicate?'"
										[color]="'accent'" (onConfirm)="revertDuplicateResolutionDifferent(dr)"
										[disabled]="dr.RESOLVING">
									</confirm-popover>
									<mat-icon *ngIf="dr.RESOLVING">
										<mat-spinner diameter="20"> </mat-spinner>
									</mat-icon>
								</td>
								<td colspan="11">
									Is this incorrect? Changing the status to Provisional will
									allow
									the
									regions to update their decision. Children will retain their new MSD
									Numbers.
									However
									merging
									them will disable the higher MSD Number.
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
				<div class="row" *ngIf="dr.DUPLICATE_RESOLUTION_TYPES.TYPE !== 'Resolved'" class="italic primary">
					<div class="col">Please <a class="cursor-pointer" (click)="reloadRoute()">refresh</a> the
						page or go to the <a
							href="{{'/children/deduplication/region/' + regionCode + '/unresolved'}}">unresolved
							page</a> to update any decisions.</div>
				</div>
			</mat-card-actions>
		</mat-card>
	</div>
	<mat-paginator [length]="duplicateResolutionsDataSource.filteredData.length" [pageSize]="pageSize"
		[pageSizeOptions]="[5, 10, 20, (duplicateResolutionsDataSource.data ? duplicateResolutionsDataSource.data.length > 100 ? duplicateResolutionsDataSource.data.length : 100 : 100)]"
		(page)="onPageChange($event)" showFirstLastButtons>
	</mat-paginator>

</div>

<div class="margin-top-md"
	*ngIf="!isLoading && routeMsg.SUCCESS && (!duplicateResolutions || duplicateResolutions.length == 0)">
	There are no Resolved duplicates.
</div>


<div class="margin-top-md" *ngIf="!isLoading && !routeMsg.SUCCESS">
	{{routeMsg.MSG}}
</div>